<template>
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div class="">
      <div class="bold fs-14">链接:</div>
      <div class="m-t-10">
        <tooltip style="width: 100%"
                 :disabled="!iteminfo.config.jumpObj.linkUrl"
                 max-width="300">
          <Input element-id="input" ref="Input" placeholder="加载链接地址" id="input-product"
                 readonly clearable
                 v-model="iteminfo.config.jumpObj.linkUrl">
            <!--                 @on-change="visibilityChange"-->

            <span slot="append" class="icon-link" style="cursor: pointer"
                 @click="showMaterialModal()"></span>
          </Input>
          <div slot="content" style="white-space: normal;">
            {{ iteminfo.config.jumpObj.linkUrl }}
          </div>
        </tooltip>
      </div>
    </div>

    <material-choice-widget
      title="选择链接"
      :pages="choosePage()"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import RatioDiv from '../../common/RatioDiv'
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'

export default {
  name: 'LandingPageSettingWidget',
  components: {RatioDiv, BaseSettingWidget, MaterialChoiceWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      showTooltip: false,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },

    /**
     * 落地页和引导页,筛选看只显示落地页和引导页
     */
    choosePage(){
      if (this.iteminfo.config.displayType===2){ //落地页
        return getPages([0])
      }else{    //引导页
        return getPages([1])
      }
    },
    showMaterialModal () {
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        this.iteminfo.config.jumpObj.linkUrl = data[0].url
        this.$nextTick(() => {
          this.checkInputOverflow()
        })
      }
    },

    /**
     * input输入框是否超出
     */
    checkInputOverflow () {
      let input = document.getElementById('input')
      if (input) {
        this.showTooltip = input.clientWidth < input.scrollWidth
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>

<style>
.ivu-input[disabled]{
  background-color: #fff;
}
</style>